module.exports = "./img/374a666d79770ad8d48e0174ff7c2de0.jpg";